module.exports = __webpack_public_path__ + "static/img/banner.d040ff14.png";